var React = require('react');

function IconPlacebo (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#142b6f;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}")),React.createElement("path",{"d":"M26.3,6.59,9.73,11.25a5.66,5.66,0,0,0-4,4A5.75,5.75,0,0,0,7.2,20.82a5.64,5.64,0,0,0,5.49,1.46l16.65-4.69a5.77,5.77,0,0,0,4-4.07,5.57,5.57,0,0,0-1.53-5.47A5.78,5.78,0,0,0,26.3,6.59Z","className":"cls-1","key":1}),React.createElement("path",{"d":"M25.35,12.81,11.73,23.33A5.67,5.67,0,0,0,9.5,28.59,5.74,5.74,0,0,0,13,33.15a5.65,5.65,0,0,0,5.64-.7L32.29,21.86a5.75,5.75,0,0,0,2.17-5.25A5.56,5.56,0,0,0,31,12.11a5.78,5.78,0,0,0-5.64.7Z","className":"cls-1","key":2})]);
}

IconPlacebo.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 40 40"};

module.exports = IconPlacebo;

IconPlacebo.default = IconPlacebo;
